import { CancelToken } from "axios";
import { A11yStandardType } from "../models/utils";
import axios from "../utils/axios";
import {getReplacedTextForStandards} from "../utils/functions";


// http://localhost:3000/standards/35fe7c64-4094-4498-89ec-918d2172ae31/undefined/questionnaires-a11y-standards/

export function fetchA11yStandard(token: string, cancelToken?: CancelToken) {
    let url = `${process.env.REACT_APP_A11Y_API_DOMAIN}/questionnaires-a11y-standards/`
    const isQmsLive = localStorage.getItem('qms-live');
    if (isQmsLive) url += 'live/'
    return axios.get<A11yStandardType[]>(url, {})
      .then((response) => ({
          ...response,
          data: getReplacedTextForStandards(response.data)
      }))
}